import { z } from "zod"

// Phone regex: allows +, digits, spaces, dashes, parentheses, dots
// Rejects obvious non-phone strings like "abc" (FM2)
const PHONE_REGEX = /^[+\d\s\-().]*$/

export const contactFormSchema = z.object({
  topic: z.enum(["general", "press", "collaborations", "events"]).default("general"),

  name: z
    .string()
    .transform((v) => v.trim())
    .pipe(z.string().min(1, "requiredField").max(255, "nameTooLong")),

  email: z
    .string()
    .transform((v) => v.trim().toLowerCase())
    .pipe(z.string().min(1, "requiredField").email("invalidEmail").max(255, "invalidEmail")),

  phone: z
    .string()
    .optional()
    .transform((v) => (v ?? "").trim())
    .pipe(
      z
        .string()
        .max(50, "invalidPhone")
        .refine((v) => v === "" || PHONE_REGEX.test(v), "invalidPhone")
        .refine((v) => v === "" || /\d/.test(v), { message: "invalidPhone" }),
    ),

  message: z
    .string()
    .transform((v) => v.trim())
    .pipe(z.string().min(10, "messageTooShort").max(5000, "messageTooLong")),
})

export type ContactFormData = z.infer<typeof contactFormSchema>
